import _AnalyticsService from "./AnalyticsService";

export const AnalyticsService = new _AnalyticsService();
